module.exports = vendor_f9b9575255b280f884e3;